<template>
  <div class="index" v-cloak ref="index">
    <!--<div class="header acea-row row-center-wrapper" >
      <div class="logo"><img :src="logoUrl" /></div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>-->
    <div class="slider-banner banner" v-if="banner.length > 0">
      <swiper :options="banner.length > 1 ? swiperOption : swiperOptionOne" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <!--<router-link
            :to="item.wap_url ? item.wap_url : ''"
            class="search acea-row row-middle"
          >-->
          <img :src="item.pic" />
          <!--</router-link>-->
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- 公告 -->
    <div class="scrolling-subtitle" v-if="announcement">
      <div class="img-wrap">
        <img :src="require('@/assets/images/index-scrolling-subtitle.png')" />
      </div>
      <span class="sub-title">{{announcement}}</span>
    </div>

    <div class="nav acea-row" v-if="menus.length > 0">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img :src="item.pic" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div>
    <div
      class="specialArea acea-row row-between-wrapper"
      v-if="activity.length"
    >
      <router-link
        :to="activityOne.wap_link ? activityOne.wap_link : ''"
        class="assemble"
      >
        <img :src="activityOne.pic" />
        <div class="text">
          <div class="name">{{ activityOne.title }}</div>
          <div class="infor">{{ activityOne.info }}</div>
        </div>
      </router-link>
      <div class="list acea-row row-column-between">
        <router-link
          :to="item.wap_link ? item.wap_link : ''"
          class="item"
          v-for="(item, index) in activity"
          :key="index"
        >
          <img :src="item.pic" />
          <div class="text">
            <div class="name">{{ item.title }}</div>
            <div class="infor">{{ item.info }}</div>
          </div>
        </router-link>
      </div>
    </div>
    <div class=" bg-color-F8F8F8 wrapper">
      <!-- <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">商品</div>
          <div class="line1" v-if="false">{{ info.bastInfo }}</div>
        </div>
            <div class="wrapper" v-if='couponsList[0] && (couponsList[0].coupon_type == 2)'>
                </div>
        <router-link :to="{ path: '/hot_new_goods/' + 1 }"  v-else class="more"
          >更多好物<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="slider-banner boutique" v-if="false">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.bastBanner"
            :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
              ><img :src="item.img"
            /></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
      </div> -->

      <!-- 商品分类-导航栏-横向滑动 -->
      <div class="wrap-fixed">
        <div :class="{'hozFixed':hozFixed}" v-if="hozData.length > 0" >
          <div class="page-relative categorize-wrap">
            <div class="movie-horizontal-scroll-bar">
              <div class="page-inline-block horizontal-div" :class="{'on': currentType == ind}" v-for="(item, ind) in hozData" :key="ind" @click="getTypeDataFn(item.cates_title_id)">{{item.title}}</div>
            </div>
            <img class="page-absolute changeGrid" @click="changeStyle" :src="changeGrid ? require('@/assets/images/index-change-top-bottom.png') : require('@/assets/images/index-change-left-right.png')" />
          </div>
        </div>
        <!-- 商品分类 -->
        <div class="shop-categorize" v-else>
          <div class="movie-box acea-row row-between row-middle default-categorize">
            <span>全部商品</span>
            <img @click="changeStyle" :src="changeGrid ? require('@/assets/images/index-change-top-bottom.png') : require('@/assets/images/index-change-left-right.png')" />
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <!-- <Good-list :good-list="info.bastList" :is-sort="false" :couponsList='couponsList'></Good-list> -->
      <GoodsList v-show="!changeGrid" :shopList="bastList" :couponsList="couponsList"></GoodsList>
      <HorizontalList v-show="changeGrid" :shopList="bastList" :couponsList="couponsList"></HorizontalList>

    </div>
    <div v-if="lovely.img">
      <div class="adver">
        <img :src="lovely.img" />
      </div>
    </div>
    <!--<div class="wrapper" v-if="info.firstList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">
            首发新品<span class="new font-color-red">NEW~</span>
          </div>
          <div class="line1">{{ info.firstInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.firstList"
            :key="index"
          >
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="img-box">
                <img :src="item.image" />
              </div>
              <div class="pro-info line1">{{ item.store_name }}</div>
              <div class="money font-color-red">点{{ item.price }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>-->
    <!--<Promotion-good :benefit="benefit"></Promotion-good>-->
    <Coupon-window
      v-if="isNotOpenCouponWindow && tipImage"
      :image="tipImage"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>

    <div class="bg-color-F8F8F8" style="height:1.2rem; text-align:center;" v-if="bastListCutAll.length > 0">
       <button @click="loadMoreData" style="margin: .3rem auto 0;" v-if="isLoadTitle">点击加载更多数据</button>
       <span style="margin: .3rem 0;" v-else>没有更多数据了</span>
    </div>

    <!-- 新增某个区间用户可以在一个点券基础上叠加点券绑定 -->
    <AddCoupon @closeMask="closeAddCouponMask" :isShow="isShowAddCoupon" :currentCoupon="couponsList[0] && couponsList[0].coupon_title"></AddCoupon>

    <div class="add-cop" v-if="isOpenAddCoupon">
        <img src="@assets/images/index-add-coupon.png" @click="closeAddCouponMask(true)"/>
    </div>

  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
// import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare, getIndexTypeList, getTypeData } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAppMessage, openShareTimeline, ready } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { getUser, getMenuUser, getLogout, getCouponsUser} from "@api/user";
import AddCoupon from "@components/AddCoupon.vue";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import sendVerifyCode from "@mixins/SendVerifyCode";
import GoodsList from "./components/GoodsList.vue";
import HorizontalList from "./components/HorizontalList.vue";

const HAS_COUPON_WINDOW = "has_coupon_window";
let fromRoute = null;
let current_couponId = null;// 切换专区

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    // PromotionGood,
    CouponWindow,
    AddCoupon,
    GoodsList,
    HorizontalList
  },
  mixins: [sendVerifyCode],
  props: {},
  watch: {
    $route: function (n) {
      if (n.name === "Index" && fromRoute == "User") {
        this.getDataFn();
      } else if ( current_couponId != cookie.get("couponId")) {
        current_couponId = cookie.get("couponId");
        this.getDataFn();
      }
    }
  },
  data: function() {
    return {
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      //
      bastListCutAll: [],//分割开的列表数据
      bastList: [],// 当前列表数据
      bastCurrentIndex: 0,
      bastLimit: 100,
      isLoadTitle: false,
      scrollEnd: 0,
      //
      lovely: {},
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperOptionOne: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: false,
        loop: false,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      couponsList:[],
      //
      isShowAddCoupon: false,
      couponArray: [
        { minCoupon: "80020684", maxCoupon: "80020687"},
        { minCoupon: "80016562", maxCoupon: "80016640"},
        { minCoupon: "80018328", maxCoupon: "80020676"},
        { minCoupon: "80021188", maxCoupon: "80021191"},
        { minCoupon: "80020830", maxCoupon: "80021061"}
      ],
      isOpenAddCoupon: false,
      //不弹提示框的号段
      notOpenCouponWindow: [
        { minCoupon: "80020729", maxCoupon: "80020829"}
      ],
      isNotOpenCouponWindow: true,
      // 发货提醒图片
      tipImage: "",
      // 切换列表排版
      changeGrid: false,
      // 导航条数据 测试数据
      hozData: [],
      currentType: 0,
      hozFixed: false,
      // 公告
      announcement: "",
      //区号
      block_id: ""
    };
  },
  mounted: function() {
    current_couponId = cookie.get("couponId");
    this.getDataFn();
  },
  methods: {
    getTypeDataFn(id) {
      this.currentType = id;
      this.bastListCutAll = [];
      this.bastList = [];
      this.isLoadTitle = false;
      this.bastCurrentIndex = 0;
      getTypeData(this.block_id, id).then((res)=>{
        if (res.status == 200) {
          this.$set(this.info, "bastList", res.data);
          this.cutList();
        }
      });
      this.$nextTick(()=>{
        window.scrollBy({ top: 230, left: 0, behavior: "auto" });
    });
    },
    loadMoreData(){
        ++this.bastCurrentIndex;
        this.bastList = this.bastList.concat(this.bastListCutAll[this.bastCurrentIndex]);
        if (this.bastCurrentIndex >= this.bastListCutAll.length-1) {
          this.isLoadTitle = false;
        }
    },
    changeStyle() {
      this.changeGrid = !this.changeGrid;
    },
    cutList() {
      if (this.info && this.info.bastList && this.info.bastList.length > 0) {
         let list = this.info.bastList;
         let allnum = parseInt(list.length/this.bastLimit);
         let newList = [];
         for(let i = 0; i < allnum; i++ ) {
           newList.push(list.splice(0, this.bastLimit));
         }
         if (list.length > 0) newList.push(list);
         this.bastListCutAll = newList;
         this.bastList = newList[0];
         this.bastCurrentIndex = 0;
         if (this.bastListCutAll.length > 1) this.isLoadTitle = true;
        //  console.log(this.bastListCutAll,"this.bastListCutAll");
      }
    },
    // 绑手机号
    closeBindFn() {
      this.isBind = false;
    },
    getCaptBind: function () {
      let imgPath = this.imgCodeUrlces.split('?')[0]+'?id='+parseInt(Math.random()*100000);
      this.imgCodeUrlces = imgPath;
    },
    async bindCode() {
      const { bindPhone } = this;
      try {
        await this
          .$validator({
            bindPhone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ bindPhone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      if (this.bindImgCode) {
        await registerVerify({ phone: this.bindPhone, type: "register",  verify: this.bindImgCode })
        .then(res => {
          this.$dialog.success(res.msg);
          this.sendCode();
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
      } else {
        this.$dialog.error("请输入验证码！");
      }
    },
    // 绑定手机号
    loginBindPhone() {
      if (!this.bindPhone || !this.bindCaptcha) return this.$dialog.error("请输入完整手机号和验证码！");
        let datas = {
          phone: this.bindPhone,
          captcha: this.bindCaptcha
        };
        bindPhone(datas).then((res)=>{
            if (res.status == 200) {
              this.$dialog.success(res.msg);
              this.closeBindFn();
            }
        }).catch((err)=>{
          this.$dialog.error(err.msg);
        })
    },
    //
    closeAddCouponMask: function (val) {
      this.isShowAddCoupon = val;
    },
    getDataFn: async function () {
        let that = this;
        this.couponsList = [];
        this.couponList = [];
        this.banner = [];
        this.menus = [];

        this.hozData = [];
        this.currentType = 0;
        this.hozFixed = false;
        this.block_id = "";
        this.changeGrid = false;
        this.tipImage = "";

        this.info = {
          fastList: [],
          bastBanner: [],
          firstList: [],
          bastList: []
        };
        //
        this.bastListCutAll= [];
        this.bastList = [];
        this.bastCurrentIndex = 0;
        this.isLoadTitle = false;
        this.scrollEnd = 0;

        await getCouponsUser(0).then(res => {
            this.couponsList = res.data;
            let card = res && res.data && res.data[0] && res.data[0].coupon_title || "";
            if (!card) {
              this.$router.replace("/loginget");
              return;
            }

            let isFalse = false;
            for(let i = 0; i<this.couponArray.length; i++) {
              if (card >= this.couponArray[i].minCoupon && card <= this.couponArray[i].maxCoupon) {
                isFalse = true;
              }
            }

            if (isFalse) {
              this.isShowAddCoupon = true;
              this.isOpenAddCoupon = true;
            } else {
              this.isShowAddCoupon = false;
              this.isOpenAddCoupon = false;
            }
            // 是否为不弹弹窗的号段
            for(let t = 0; t<this.notOpenCouponWindow.length; t++) {
                if ( card >= this.notOpenCouponWindow[t].minCoupon && card <= this.notOpenCouponWindow[t].maxCoupon ) {
                    this.isNotOpenCouponWindow = false;
                } else if ( card == 80021193) {
                    this.isNotOpenCouponWindow = false;
                } else {
                  this.isNotOpenCouponWindow = true;
                }
            }
        });
        await getHomeData().then(res => {
            if (res.status == 200) {
                  this.tipImage = res.data.sendImg || "";
                   // 正常
                  that.logoUrl = res.data.logoUrl;
                  that.$set(that, "banner", res.data.banner);
                  that.$set(that, "menus", res.data.menus);
                  that.$set(that, "activity", res.data.activity);
                  var activityOne = res.data.activity.shift() || {};
                  that.$set(that, "activityOne", activityOne);
                  that.$set(that, "info", res.data.info);
                  // 公告
                  if (res.data.roll.length > 0) {
                    this.announcement = res.data.roll.reduce((pre,cur,i)=>{ return pre+cur.info+'    ';}, "") || '';
                  }
                  //
                  that.$set(
                    that,
                    "lovely",
                    res.data.lovely.length ? res.data.lovely[0] : {}
                  );
                  that.$set(that, "benefit", res.data.benefit);
                  that.$set(that, "couponList", res.data.couponList);
                  //
                  this.block_id = res.data.now_cate || "";
                  this.cutList();
                  //
                  document.title = res.data.site_name;
                  // that.setOpenShare();
                  this.showCoupon =
                    !cookie.has(HAS_COUPON_WINDOW) &&
                    res.data.couponList.some(coupon => coupon.is_use);
              }
        });
        await getIndexTypeList(this.block_id).then((res)=>{
            if (res.status == 200) {
              this.hozData = res.data;
              this.currentType = 0;
            }
        })
        this.$scroll(this.$refs.index, this.handleScroll, this.lister);
    },
    lister(e) {
      let scrolly = e.scrollY;
      // console.log(scrolly, "滚动条--")
      if (scrolly > 250) {
        this.hozFixed = true;
      }
      if (this.hozFixed && scrolly < 240) {
        this.hozFixed = false;
      }
    },
    handleScroll() {
      // 调起
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    setOpenShare: function() {
      getShare().then(res => {
        var data = res.data.data;
        var configAppMessage = {
          desc: data.synopsis,
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        var configTimeline = {
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        if (isWeixin() === true) {
          ready().then(() => {
            openShareAppMessage(configAppMessage).then(() => {});
            openShareTimeline(configTimeline).then(() => {});
          });
        }
      });
    }
  },
  beforeRouteEnter: function (to, from, next) {
    if (from.name == "User" && to.name == "Index" && to.params.id == "0") {
        fromRoute = from.name;
        next();
    }
    next();
  },
  activated: function () {
    this.$nextTick(()=>{
      window.scrollBy({ top: this.scrollEnd, left: 0, behavior: "auto" });
    });
  },
  beforeRouteLeave: function (to, from, next) {
      this.scrollEnd = window.scrollY;
      next();
  }
};
</script>
<style scoped lang="scss">
.wrapper {
  width: 100%;
}
// 分类导航
.default-categorize {
  padding: 0.32rem 0.32rem 0.2rem;
  height: 1.1rem;
  span {
    font-size: 0.32rem;
  }
  img {
    width: 0.36rem;
    height: 0.36rem;
  }
}
.wrap-fixed {
  height: 1.1rem;
  width: 100%;
}
.hozFixed {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 5;
}
.categorize-wrap {
  width: 100%;
  height: 1.1rem;
  padding: 0.32rem .8rem 0.32rem 0.32rem;
  .changeGrid {
    width: 0.36rem;
    height: 0.36rem;
    right: 0.32rem;
    top: 0.36rem;
  }
  .horizontal-div {
    margin-right: 0.48rem;
    color: #242424;
    font-size: 0.32rem;
  }
  .horizontal-div.on {
    color: #F6433D;
  }
}
//
.scrolling-subtitle {
  width: 100%;
  height: .5rem;
  line-height: .4rem;
  overflow: hidden;
  position: relative;
  .img-wrap {
    width: 0.66rem;
    background:#fff;
    position: absolute;
    z-index: 10;
    top: .07rem;
    img {
      margin-left: 0.32rem;
      width: 0.3rem;
      height:auto;
    }
  }
  .sub-title {
    position: absolute;
    left: 0.64rem;
    top: .04rem;
    white-space: nowrap;
    padding-left: 100%;
    animation: notice 18s 0s linear infinite both;
  }
}
@keyframes notice {
  100% {
    transform: translate3d(-100%, 0 ,0);
  }
}
  .add-cop {
    position: fixed;
    top: 15%;
    right: 0;
    width: 24px;
    height: 86px;
    z-index: 99;
  }
  .add-cop img {
    width: 100%;
    height: 100%;
    display: block;
  }
</style>
